/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Email-translation admin list and editor.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CodemirrorModule} from '../../common/directives/codemirror.module';
import {EmailTranslationEditPageComponent} from './email-translation-edit-page.component';
import {EmailTranslationListPageComponent} from './email-translation-list-page.component';
import {EmailTranslationRoutePageComponent} from './email-translation-route-page.component';

const EMAIL_TRANSLATION = [
  EmailTranslationEditPageComponent,
  EmailTranslationListPageComponent,
  EmailTranslationRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    CodemirrorModule
  ],
  declarations: EMAIL_TRANSLATION,
  exports: EMAIL_TRANSLATION
})
export class EmailTranslationModule {
}
